import { render, staticRenderFns } from "./NotificationCreate.vue?vue&type=template&id=6816dd7c&"
import script from "./NotificationCreate.vue?vue&type=script&lang=js&"
export * from "./NotificationCreate.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCreate.vue?vue&type=style&index=0&id=6816dd7c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports